import { Model } from '@vuex-orm/core';
import MemberDeviation from '@/modules/member-deviation/store/model';

class Member extends Model {
  static entity = 'members';

  static fields() {
    return {
      id: this.attr(null),
      username: this.attr(null),
      deviations: this.hasOne(MemberDeviation, 'user'),
      firstName: this.attr(null),
      lastName: this.attr(null),
      taskCount: this.attr(null),
    };
  }

  get fullName() {
    return this.firstName && this.lastName ? `${this.firstName} ${this.lastName}` : this.username;
  }

  static apiConfig = {
    actions: {
      fetchByGroupName(group) {
        return this.get(`groups/${group}/members`);
      },
      fetchByUserId(id) {
        return this.get(`users/${id}`);
      },
      update(id, data) {
        return this.patch(`users/${id}`, data);
      },
    },
  }
}

export default Member;
